import * as React from 'react';

// Types
import { IconProps } from './types';

const Location = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#E3D2FF"
      d="M15.75 19.5h-4.637a24.997 24.997 0 0 0 2.2-2.227c2.573-2.96 3.937-6.08 3.937-9.023a8.25 8.25 0 1 0-16.5 0c0 2.944 1.36 6.064 3.938 9.023A24.99 24.99 0 0 0 6.886 19.5H2.25a.75.75 0 1 0 0 1.5h13.5a.75.75 0 1 0 0-1.5ZM9 5.25a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
    />
  </svg>
);
export default Location;
